import { AxiosResponse } from "axios";

import API from "../api";

import { Location } from "../models/location";

const ROUTE_NAME = "locations";

export const LocationService = {
  async count(options?: any): Promise<AxiosResponse<number>> {
    return await API.get(`/${ROUTE_NAME}/count`, { params: options });
  },
  async getById(id: number, options?: any): Promise<AxiosResponse<Location>> {
    return await API.get(`/${ROUTE_NAME}/${id}`, { params: options });
  },
  async getAll(options?: any): Promise<AxiosResponse<Location[]>> {
    return await API.get(`/${ROUTE_NAME}`, { params: options });
  },
  async create(location: Location): Promise<AxiosResponse<Location>> {
    return await API.post(`/${ROUTE_NAME}`, location);
  },
  async update(id: number, location: Location): Promise<AxiosResponse<boolean>> {
    return await API.put(`/${ROUTE_NAME}/${id}`, location);
  },
  async delete(id: number): Promise<AxiosResponse<Location>> {
    return await API.delete(`/${ROUTE_NAME}/${id}`);
  },
};
